import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@teo/components';
import {
  City,
  PencilFilled,
  Person,
  TrashIcon,
  Plus,
} from '@teo/components/icons';
import AddContenModal from '../ModalLP/AddContenModal';
import { useGet } from '@/query/fetchHooks';
import MapLocation from './MapLocation';

const PracticalInformationLP = ({
  authOrg,
  trainingDetail,
  typeOfTraining,
  handleChangeTraining,
}) => {
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [info, setInfo] = useState();
  const [location, setLocation] = useState(trainingDetail?.location || '');
  const [trainingInstitution, setTrainingInstitution] = useState(null);
  const [trainingPersonIds, setTrainingPersonIds] = useState(
    trainingDetail?.contactPersonIds || []
  );
  const [institution, setInstitution] = useState(null);
  const [institutionEmail, setInstitutionEmail] = useState(null);
  const [institutionPhone, setInstitutionPhone] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [typeModal, steTypeModal] = useState('');
  const [registrationLink, setRegistrationLink] = useState(
    trainingDetail?.url || ''
  );

  const [activePerson, setActivePerson] = useState(null);
  const [persons, setPersons] = useState([]);

  useGet(`/contact/${trainingDetail?.institutionId}`, {
    retry: false,
    enabled: !!trainingDetail?.institutionId,
    onSuccess: (result) => {
      setTrainingInstitution(result?.data);
      setInstitution(result?.data?.contactName || '');
      setInstitutionEmail(result?.data?.contactEmail || '');
      setInstitutionPhone(result?.data?.contactPhone || '');
    },
  });
  useGet(
    `/trainingcontacts?trainingId=${trainingDetail?.id}&organisationId=${authOrg},OR,organisationId=null&contactType=person`,
    {
      retry: false,
      enabled: !!trainingDetail?.id,
      onSuccess: (result) => {
        setPersons(result?.data);
      },
    }
  );

  useEffect(() => {
    const googleScript = document.createElement('script');
    googleScript.type = 'text/javascript';
    googleScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBXCsHIDS0RXugO_KyoWUvE0ThKGBpAxUs&libraries=places`;
    window.document.body.appendChild(googleScript);

    googleScript.addEventListener('load', () => {
      setloading(true);
    });
  }, []);

  return (
    <div className="mt-5 border-t px-5 py-5">
      <h4 className="mb-1 text-base">
        {t('pages.learning_path.practical_information_label')}
      </h4>

      {((trainingDetail?.trainingType === 'training' &&
        typeOfTraining === 'external') ||
        trainingDetail?.trainingType === 'evaluation') && (
        <div className="mt-5">
          <label className="mb-1 block text-sm font-semibold text-black">
            {trainingDetail?.trainingType === 'evaluation'
              ? t('pages.learning_path.settings.evaluation_institution')
              : t('pages.learning_path.settings.training_institution')}
          </label>

          {institution || institutionEmail || institutionPhone ? (
            <div className="flex rounded-lg border border-grey-02 p-4">
              <div className="flex flex-col gap-2">
                <div className="flex w-full">
                  <City className="h-5 w-5" />
                </div>
                <h4>{institution}</h4>
                <a
                  className="text-sm text-[#1173DD]"
                  href="mailto:info@teo.training"
                >
                  {institutionEmail}
                </a>
                <p className="text-sm text-[#1E1E20A8]">{institutionPhone}</p>
              </div>
              <div className="ml-auto flex min-w-[30px] flex-col gap-2 pl-2">
                <IconButton
                  className="ml-auto  -mt-[6px] -mr-[6px] !text-[#1E1E20C7]"
                  Icon={PencilFilled}
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    steTypeModal('institution');
                    setIsOpenModal(true);
                  }}
                />
                <IconButton
                  className="ml-auto  -mt-[6px] -mr-[6px] !text-error-04 "
                  Icon={TrashIcon}
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    setInstitution(null);
                    setInstitutionEmail(null);
                    setInstitutionPhone(null);
                    setTrainingInstitution(null);
                    handleChangeTraining({ institutionId: null });
                  }}
                />
              </div>
            </div>
          ) : (
            <Button
              variant="ghost"
              className="flex w-full items-center gap-2 border !border-grey-02 !p-4 !text-[#1E1E2080]"
              onClick={() => {
                steTypeModal('newInstitution');
                setIsOpenModal(true);
              }}
            >
              {t('pages.learning_path.settings.no_add_institution')}
              <Plus className="ml-auto w-5 text-[#4D4D50]" />
            </Button>
          )}
        </div>
      )}
      {(typeOfTraining !== 'online' ||
        trainingDetail?.trainingType === 'evaluation') && (
        <div className="mt-5">
          {loading && (
            <MapLocation
              setInfo={setInfo}
              info={info}
              setLocationStr={setLocation}
              locationStr={location}
              handleChangeTraining={handleChangeTraining}
              trainingDetail={trainingDetail}
            />
          )}
        </div>
      )}

      {(typeOfTraining !== 'internal' ||
        trainingDetail?.trainingType === 'evaluation') && (
        <div className="mt-5">
          <label className="mb-1 block text-sm font-semibold text-black">
            {t('pages.learning_path.settings.link_registration')}
          </label>
          {registrationLink ? (
            <div className="flex items-start rounded-lg border border-grey-02 p-4">
              <a
                href="www.leercentrum.be/opleidingen/brandveiligheid101/inschrijven"
                className="break-all text-sm text-[#1173DD]"
              >
                {registrationLink}
              </a>
              <div className="ml-auto">
                <IconButton
                  className="ml-2 -mt-[6px] -mr-[6px] !text-[#1E1E20C7]"
                  Icon={PencilFilled}
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    steTypeModal('link');
                    setIsOpenModal(true);
                  }}
                />
              </div>
            </div>
          ) : (
            <Button
              variant="ghost"
              className="flex w-full items-center gap-2 border !border-grey-02 !p-4 !text-[#1E1E2080]"
              onClick={() => {
                steTypeModal('link');
                setIsOpenModal(true);
              }}
            >
              {t('pages.learning_path.settings.no_add_link')}
              <Plus className="ml-auto w-5 text-[#4D4D50]" />
            </Button>
          )}
        </div>
      )}
      {(typeOfTraining !== 'online' ||
        trainingDetail?.trainingType === 'evaluation') && (
        <div className="mt-5">
          <label className="mb-1 block text-sm font-semibold text-black">
            {t('pages.learning_path.settings.contact_person')}
          </label>
          {persons?.map((person, i) => {
            return (
              <div
                key={i}
                className="mb-2 flex rounded-lg border border-grey-02 p-4"
              >
                <div className="flex flex-col gap-2">
                  <div className="flex w-full">
                    <Person className="h-5 w-5" />
                  </div>

                  <h4>{person?.contactName}</h4>
                  <a
                    className="text-sm text-[#1173DD]"
                    href="mailto:info@teo.training"
                  >
                    {person?.contactEmail}
                  </a>
                  <p className="text-sm text-[#1E1E20A8]">
                    {person?.contactPhone}
                  </p>
                </div>

                <div className="ml-auto flex min-w-[30px] flex-col gap-2 pl-2">
                  <IconButton
                    className="ml-auto  -mt-[6px] -mr-[6px] !text-[#1E1E20C7]"
                    Icon={PencilFilled}
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      steTypeModal('person');
                      setIsOpenModal(true);
                      setActivePerson(person);
                    }}
                  />
                  <IconButton
                    className="ml-auto  -mt-[6px] -mr-[6px] !text-error-04 "
                    Icon={TrashIcon}
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      const newPersonsList = trainingPersonIds?.filter(
                        (prs) => prs !== person?.id
                      );
                      setTrainingPersonIds(newPersonsList);
                      handleChangeTraining({
                        contactPersonIds: newPersonsList,
                      });
                      setPersons((prev) =>
                        prev?.filter((prs) => prs?.id !== person?.id)
                      );
                    }}
                  />
                </div>
              </div>
            );
          })}

          <Button
            variant="secondary"
            className="mt-1"
            onClick={() => {
              steTypeModal('newPerson');
              setIsOpenModal(true);
            }}
          >
            {t('pages.learning_path.settings.add_person_btn')}
          </Button>
        </div>
      )}
      {isOpenModal && (
        <AddContenModal
          onClose={() => {
            setActivePerson(null);
            setIsOpenModal(false);
          }}
          authOrg={authOrg}
          trainingDetail={trainingDetail}
          typeModal={typeModal}
          setInstitution={setInstitution}
          institution={institution}
          setInstitutionEmail={setInstitutionEmail}
          institutionEmail={institutionEmail}
          setInstitutionPhone={setInstitutionPhone}
          institutionPhone={institutionPhone}
          setRegistrationLink={setRegistrationLink}
          registrationLink={registrationLink}
          setPersons={setPersons}
          persons={persons}
          setActivePerson={setActivePerson}
          activePerson={activePerson}
          handleChangeTraining={handleChangeTraining}
          trainingInstitution={trainingInstitution}
          setTrainingInstitution={setTrainingInstitution}
          trainingPersonIds={trainingPersonIds}
          setTrainingPersonIds={setTrainingPersonIds}
        />
      )}
    </div>
  );
};

export default PracticalInformationLP;
